import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }

import HelpCard from '@/components/help/HelpCard.vue';
import HelpCenter from '@/services/help-center';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Help center',
  subtitle: 'Have problems or want to help? Do it here.',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HelpCenter), (card) => {
          return (_openBlock(), _createBlock(HelpCard, {
            key: card.id,
            card: card
          }, null, 8, ["card"]))
        }), 128))
      ])
    ])
  ]))
}
}

})